//Review Summary GI

// Define interfaces for nested objects first
interface AmenityData {
  success: boolean;
  data: Record<
    string,
    {
      rating: number;
      maxRating: number;
      per: string;
    }
  >;
}

interface GiTag {
  id?: string;
  name?: string;
  count?: number;
  sentiment?: Sentiment;
  root?: string;
  rootSlug?: string;
  tags?: string[];
}

interface GiRating {
  id: string;
  name: string;
  rating: number;
}

interface GiReviewImage {
  id: string;
  url: string;
  bigUrl: string;
  thumbUrl: string;
  mobileThumbUrl: string;
  hotelReviewId: string;
}

interface GiReview {
  id: string;
  reviewerId: string;
  reviewContent: string;
  totalRating: number;
  submittedAt: string;
  firstName: string;
  lastName: string;
  image_url: string;
  images: GiReviewImage[];
  featuredReviewTitle: string;
  reviewCount: number;
  badgeName: string;
  badgeIconUrl: string;
  date: string;
}

interface GiRwc {
  name: string;
  rating: number;
  count: number;
}

interface GiPersuasion {
  content: string;
  title: string;
  iconURL: string;
  colorCodeUp: string;
  colorCodeBottom: string;
}

interface GiSWR {
  h: string;
  sh: string;
  r: number;
}

interface GiHdpTag {
  data: {id: string; name: string}[];
  title: string;
  type: string;
}

interface GiEffectiveCategoryData {
  id: string;
  name: string;
  iconUrl: string;
  overall_rating: number;
  color_code: string;
}

interface GiSubCategory {
  name: string;
  per: number;
  colorCode: string;
}

interface GiCategoryData {
  text: string;
  type: string;
  subCategories: GiSubCategory[];
}

interface GiCsCategoryData {
  name: string;
  id: string;
  per: number;
  iconUrl: string;
  colorCode: string;
  categoryData: GiCategoryData;
}

interface GiLatestReview {
  totalRating: number;
  firstName: string;
  lastName: string;
  image_url: string | null;
}

interface GiQuestion {
  id: string;
  question: string;
  answerCount: number;
  image_url: string;
  firstName: string;
  lastName: string;
}

interface GiTopAnswer {
  id: string;
  answer: string;
  questionId: string;
  image_url: string;
  firstName: string;
  lastName: string;
  relevanceScore: number;
}

interface GiQuestionSet {
  question: GiQuestion;
  topAnswers: GiTopAnswer[];
}

interface GiData {
  reviewCount: number;
  hotelRating: number;
  questionCount: number;
  answerCount: number;
  approvedImageCount: number;
  recommendationPercent: number;
  ratingsOnlyCount: number;
  tags: GiTag[];
  ratings: GiRating[];
  reviews: GiReview[];
  rwc: GiRwc[];
  persuasion: GiPersuasion;
  recentWindowRating: number;
  recentReviewCount: number;
  swr: GiSWR;
  hdpTags: GiHdpTag[];
  rText: string;
  effectiveCategoryData: GiEffectiveCategoryData[];
  csCategoryData: GiCsCategoryData[];
  csCategoryText: string;
  cityVoyId: string;
  latestReviews: GiLatestReview[];
  questions: GiQuestionSet[];
}

interface ExtSubRating {
  title: string;
  tag: string;
  rating: number;
}

interface ExtData {
  hotelRating: number;
  reviewCount: number;
  subRating: ExtSubRating[];
  posTags: any[];
  negTags: any[];
}

// Define the main interface using the nested interfaces
export interface ReviewSummaryGI {
  giDataExists: boolean;
  taDataExists: boolean;
  extDataExists: boolean;
  expDataExists: boolean;
  ugcSrc: string;
  context: null;
  preferredReviewSource: string[];
  ugcFunnelReviewSrc: string;
  amenityData: AmenityData;
  giFeaturedReviewsHeading: string;
  giData: GiData;
  taData: GiData;
  expData: GiData;
  extData: ExtData;
}

export enum Sentiment {
  Neu = 'NEU',
  Pos = 'POS',
}

export interface UgcV2Review {
  cumulativeRating: number;
  isNewListing: boolean;
  ratingCount: number;
  source: string;
}
